import { __extends } from "tslib";
import { ASObject } from '@awayfl/avm2';
/**
 * Copyright 2014 Mozilla Foundation
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
// Class: BitmapFilterType
var BitmapFilterType = /** @class */ (function (_super) {
    __extends(BitmapFilterType, _super);
    function BitmapFilterType() {
        return _super.call(this) || this;
    }
    // Called whenever the class is initialized.
    BitmapFilterType.classInitializer = null;
    // List of static symbols to link.
    BitmapFilterType.classSymbols = null; // [];
    // List of instance symbols to link.
    BitmapFilterType.instanceSymbols = null; // [];
    // JS -> AS Bindings
    BitmapFilterType.INNER = 'inner';
    BitmapFilterType.OUTER = 'outer';
    BitmapFilterType.FULL = 'full';
    return BitmapFilterType;
}(ASObject));
export { BitmapFilterType };
